import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { TermoCondicaoService } from './termo-condicao.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-termo-condicao',
  templateUrl: './termo-condicao.component.html',
  styleUrls: ['./termo-condicao.component.scss']
})
export class TermoCondicaoComponent implements OnInit {

  public cnpjCpfLido: string;
  public cnpjCpfRecebedor: string;
  public valor: number;
  public dataLocalUrl = null;
  public id = null;
  public customLogin = null;

  constructor(
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private service: TermoCondicaoService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private encriptyService: EncriptyUtilService,
  ) {

    this.spinnerService.show();

    this.service.generatebase64(null, (response => {

      this.spinnerService.hide();
      if (response) {
        this.dataLocalUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + response.valorBinario);
      }

    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.activatedRoute.queryParamMap.subscribe(params => {

      this.id = this.encriptyService.decriptyBySecretKey(params.get('id'));
      this.cnpjCpfLido = this.encriptyService.decriptyBySecretKey(params.get('cnpjCpfLido'));
      this.cnpjCpfRecebedor = this.encriptyService.decriptyBySecretKey(params.get('cnpjCpfRecebedor'));
      this.valor = this.encriptyService.decriptyBySecretKey(params.get('valor'));

    });

  }

  termoCondicao() {

    let id = this.id;

    let params = {
      'id': id,
      'tela': 'termo'
    }

    let register = {
      cnpjCpfLido: this.cnpjCpfLido,
      cnpjCpfRecebedor: this.cnpjCpfRecebedor,
      valorCerc: this.valor,

    }

    this.service.salveAceiteTermo(register, (response => {

      this.router.navigate(['/pages/compra-online/detalhe-pedido'], { relativeTo: this.activatedRoute, queryParams: params });

    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  voltar() {
    this.router.navigate(['/pages/compra-online/consulta-pedido-recebido']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
